import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-enps-help-modal',
  templateUrl: './enps-help-modal.component.pug',
  styleUrls: ['./enps-help-modal.component.scss'],
  standalone: false
})
export class EnpsHelpModalComponent implements OnInit {
  @Input() request: any;

  constructor(
    public _bsModalRef: BsModalRef,
    public permissionService: PermissionsService
  ) {}

  ngOnInit(): void {
  }
  close() {
    this._bsModalRef.hide();
  }
}
